<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mr-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Edit User Monthly Job Request
        </v-card-title>
        <page-loader :loading="isFetching" />
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-text-field
                v-model="form.user.user_name"
                outlined
                readonly
                hide-details="auto"
                label="Name"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.user_address.lat"
                outlined
                readonly
                label="Address Latitude"
                hide-details="auto"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.user_address.long"
                outlined
                readonly
                label="Address Longitude"
                hide-details="auto"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col>
            <v-col sm="12">
              <v-textarea
                v-model="form.user_address.address"
                outlined
                readonly
                label="Address"
                hide-details="auto"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-textarea>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.month"
                outlined
                label="Month"
                hide-details="auto"
                readonly
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.year"
                outlined
                hide-details="auto"
                readonly
                label="Year"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.plan_name"
                hide-details="auto"
                readonly
                outlined
                label="Plan Name"
                append-icon="mdi-eye"
                @click:append="showPlanDetails"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.start_date"
                outlined
                hide-details="auto"
                readonly
                label="Start Date"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.end_date"
                hide-details="auto"
                readonly
                outlined
                label="End Date"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col>
            <v-col lg="4" md="4" sm="4" cols="12">
              <v-autocomplete
              v-model="form.franchisee_approval_status"
              outlined
                :readonly="positionName == 'FRANCHISEE ADMIN' ? false : true"
              hide-details="auto"
              :items="statusItems"
              label="Franchisee Approval Status"
              prepend-inner-icon="mdi-checkbox-marked-circle-outline"
              ></v-autocomplete>
            </v-col>
            <v-col lg="4" md="4" sm="4" cols="12" v-if="visible_to(['ADMIN']) && form.franchisee_approval_status != 0"> 
              <v-autocomplete
                v-model="form.status"
                outlined
                hide-details="auto"
                :items="statusItems"
                label="Status"
                prepend-inner-icon="mdi-checkbox-marked-circle-outline"
              ></v-autocomplete>
            </v-col>
            <v-col sm="4" v-if="form.franchisee_approval_status == 1">
              <v-autocomplete
                ref="status"
                outlined
                hide-details="auto"
                :loading="isMasterLoading"
                @click:clear="form.walker_id = null"
                v-model="form.walker_id"
                :items="walkerItems"
                label="Walker"
                hint="Only KYC verified walkers can be assigned"
                persistent-hint
                prepend-inner-icon="mdi-account"
                clearable
              ></v-autocomplete>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.timeslot"
                hide-details="auto"
                :readonly="positionName == 'FRANCHISEE ADMIN' ? false : true"
                outlined
                label="Timeslot"
                prepend-inner-icon="mdi-card-text-outline"
                ></v-text-field>
              </v-col>
              <v-col sm="4" v-if="form.timeslot_2">
                <v-text-field
                v-model="form.timeslot_2"
                hide-details="auto"
                :readonly="positionName == 'FRANCHISEE ADMIN' ? false : true"
                outlined
                label="Timeslot 2"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col>
            <v-col lg="4" md="4" sm="4" cols="12" v-if="form.franchisee_approval_status == 2">
              <v-text-field
                v-model="form.remark"
                outlined
                hide-details="auto"
                :readonly="positionName == 'FRANCHISEE ADMIN' ? false : true"
                label="Remark"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-switch
                class="mt-0 ml-5"
                v-model="form.is_active"
                inset
                :label="`Is Active: ${form.is_active ? 'YES' : 'NO'}`"
              ></v-switch>
            </v-col>
          </v-row>
          <v-divider class="my-5"> </v-divider>
          <v-btn v-can:edit="'monthly_bookings'"
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Update User Monthly Job Request
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
    <!-- Restore Success Dialog Box -->
    <v-dialog v-model="show_plan_pop_up" width="800">
      <v-card rounded="xxl">
        <v-container>
          <v-row align="center">
            <v-col align="center">
              <v-card-text>
                <v-row>
                  <v-col>
                    <h1 style="color: green">Plan Details</h1>
                    <br />
                    <v-simple-table
                      fixed-header
                      class="striped-table"
                      border="1"
                      style="border: solid windowtext 0.5pt; min-width: 150px"
                    >
                      <template v-slot:default>
                        <tr class="table-row-even">
                          <th
                            style="
                              border: solid windowtext 0.5pt;
                              min-width: 150px;
                            "
                          >
                            No.Of Dogs
                          </th>
                          <td
                            style="
                              border: solid windowtext 0.5pt;
                              min-width: 150px;
                            "
                          >
                            <b>{{ plan_details.no_of_dogs }}</b>
                          </td>
                          <th
                            style="
                              border: solid windowtext 0.5pt;
                              min-width: 150px;
                            "
                          >
                            No.Of Walks
                          </th>
                          <td
                            style="
                              border: solid windowtext 0.5pt;
                              min-width: 150px;
                            "
                          >
                            <b>{{ plan_details.no_of_walks }}</b>
                          </td>
                          <th
                            style="
                              border: solid windowtext 0.5pt;
                              min-width: 150px;
                            "
                          >
                            Tiers
                          </th>
                          <td
                            style="
                              border: solid windowtext 0.5pt;
                              min-width: 150px;
                            "
                          >
                            <b>{{ plan_details.tier }}</b>
                          </td>
                        </tr>
                        <tr>
                          <th
                            style="
                              border: solid windowtext 0.5pt;
                              min-width: 150px;
                            "
                          >
                            Original Amount
                          </th>
                          <td
                            style="
                              border: solid windowtext 0.5pt;
                              min-width: 150px;
                            "
                          >
                            <b>{{ plan_details.original_amount }}</b>
                          </td>
                          <th
                            style="
                              border: solid windowtext 0.5pt;
                              min-width: 150px;
                            "
                          >
                            Discount
                          </th>
                          <td
                            style="
                              border: solid windowtext 0.5pt;
                              min-width: 150px;
                            "
                          >
                            <b>{{ plan_details.discount_percent }}</b>
                          </td>
                          <th
                            style="
                              border: solid windowtext 0.5pt;
                              min-width: 150px;
                            "
                          >
                            Calculated
                          </th>
                          <td
                            style="
                              border: solid windowtext 0.5pt;
                              min-width: 150px;
                            "
                          >
                            <b>{{ plan_details.calculated_final_amount }}</b>
                          </td>
                        </tr>
                        <tr
                          class="table-row-even"
                          v-if="
                            plan_details.no_of_dogs != 1 ||
                            plan_details.no_of_walks != 1
                          "
                        >
                          <th
                            style="
                              border: solid windowtext 0.5pt;
                              min-width: 150px;
                            "
                          >
                            Second Dog/Walk Discount
                          </th>
                          <td
                            style="
                              border: solid windowtext 0.5pt;
                              min-width: 150px;
                            "
                          >
                            <b>{{ plan_details.second_discount_percent }}</b>
                          </td>
                          <th
                            style="
                              border: solid windowtext 0.5pt;
                              min-width: 150px;
                            "
                          >
                            Second discount Amount
                          </th>
                          <td
                            style="
                              border: solid windowtext 0.5pt;
                              min-width: 150px;
                            "
                          >
                            <b>{{ plan_details.second_discount_amount }}</b>
                          </td>
                          <th
                            style="
                              border: solid windowtext 0.5pt;
                              min-width: 150px;
                            "
                          >
                            Final Calculated
                          </th>
                          <td
                            style="
                              border: solid windowtext 0.5pt;
                              min-width: 150px;
                            "
                          >
                            <b>{{ plan_details.final_amount }}</b>
                          </td>
                        </tr>
                        <tr>
                          <th
                            style="
                              border: solid windowtext 0.5pt;
                              min-width: 150px;
                            "
                          >
                            Per Walk Time
                          </th>
                          <td
                            style="
                              border: solid windowtext 0.5pt;
                              min-width: 150px;
                            "
                          >
                            <b>{{ plan_details.per_walk_time }}</b>
                          </td>
                          <th
                            style="
                              border: solid windowtext 0.5pt;
                              min-width: 150px;
                            "
                          >
                            Days
                          </th>
                          <td
                            style="
                              border: solid windowtext 0.5pt;
                              min-width: 150px;
                            "
                          >
                            <b>{{ plan_details.days }}</b>
                          </td>
                          <th
                            style="
                              border: solid windowtext 0.5pt;
                              min-width: 150px;
                            "
                          >
                            Customer Per Day Charges
                          </th>
                          <td
                            style="
                              border: solid windowtext 0.5pt;
                              min-width: 150px;
                            "
                          >
                            <b>{{ plan_details.customer_per_day_charges }}</b>
                          </td>
                        </tr>
                      </template>
                    </v-simple-table>
                    <br />
                    <v-btn color="success" @click="show_plan_pop_up = false">
                      OK
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </v-main>
</template>
<script>
import axios from "axios";

export default {
  name: "UserMonthlyJobRequestEditPage",
  data() {
    return {
      form: {
        user: {},
        user_address: {},
        is_active: false,
      },
      filter: {
        franchisee_id: "",
      },
      statusItems: [
        { id: "PENDING", text: "PENDING", value: 0 },
        { id: "APPROVED", text: "APPROVED", value: 1 },
        { id: "REJECTED", text: "REJECTED", value: 2 },
      ],
      plan_details: {},
      walkerItems: [],
      isLoading: false,
      isFetching: false,
      isMasterLoading: false,
      show_plan_pop_up: false,
    };
  },
  async mounted() {
    this.isFetching = true;
    try {
      await this.getMasters();
    } finally {
      this.isFetching = false;
    }
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let encryptedId = this.$route.params.userMonthlyJobRequestId;
      axios
        .get(`/user_monthly_job_requests/${encryptedId}`)
        .then((response) => {
          this.form = response.data.data;
          this.plan_details = this.form.plan;
          this.form.plan_name =
            this.form.plan.no_of_dogs +
            " Dog- " +
            this.form.plan.no_of_walks +
            " Walk " +
            this.form.plan.tier;

          this.old_json = response.data.data;
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
      this.isLoading = false;
    },
    async save() {
      try {
        this.isLoading = true;
        console.log(this.form);
        await axios
          .patch(
            `/user_monthly_job_requests/${this.$route.params.userMonthlyJobRequestId}`,
            this.form
          )
          .then(async () => {
            await this.saveUserTimestamp(this.old_json, this.form);
            this.$router.back();
          })
          .catch((error) => {
            console.error(error);
            const status = error.response ? error.response.status : null;
            // 422 here is the backend refusing the assignment, e.g. the walker's
            // KYC is not verified - the admin has to read that, not a session popup.
            if (status === 422) {
              const data = error.response.data || {};
              const first = data.errors
                ? Object.values(data.errors)[0]
                : data.message;
              this.isShowPopUP(
                "Cannot assign this walker",
                Array.isArray(first) ? first[0] : first
              );
              return;
            }
            this.isUnAuthorised();
          });
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
      }
    },
    showPlanDetails() {
      this.show_plan_pop_up = true;
      this.plan_details = this.form.plan;
    },
    async getMasters() {
      this.isMasterLoading = true;
      this.filter.franchisee_id = this.user.franchisee_id
        ? this.user.franchisee_id
        : "";
      await axios
        .get(
          `masters?context=user_monthly_job_requests&franchisee_id=${this.filter.franchisee_id}`
        )
        .then((masters) => {
          masters = masters.data;
          masters.walkers.forEach((user) => {
            const kycVerified = user.is_kyc_verified == 1;
            this.walkerItems.push({
              id: user.id,
              text: kycVerified
                ? user.user_name
                : `${user.user_name} (KYC pending)`,
              value: user.id,
              disabled: !kycVerified,
            });
          });
        })
        .catch((error) => {
          console.error(error);
          this.isUnAuthorised();
        });
      this.isMasterLoading = false;
      this.getData();
    },
  },
};
</script>
<style scoped>
.v-data-table__wrapper {
  width: 100%;
  page-break-inside: avoid;
  border-collapse: collapse;
  border: solid windowtext 0.5pt;
  margin: 0pt !important;
}

td {
  height: 2pt !important;
  line-height: normal;
  padding: 0pt 4pt 0pt 4pt !important;
}

td > p {
  margin-top: 1pt;
  margin-right: 0;
  margin-bottom: 1pt;
  margin-left: 0;
}
</style>
